import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		name: {
			display: "inline-block",
			maxWidth: 200,
			overflow: "hidden",
			textOverflow: "ellipsis",
		}
	} satisfies Record<string, CSSObject>;
};
